import { motion } from 'framer-motion'
import { ExternalLink, Github, Calendar, Info } from 'lucide-react'
import { useState, useRef, useEffect } from 'react';

const Projects = () => {
  const [activeTooltip, setActiveTooltip] = useState(null)
  const tooltipRef = useRef(null)

  // ログイン情報をコピーする関数
  const copyLoginInfo = (e, content) => {
    e.preventDefault();
    const loginText = content.split(': ')[1];
    navigator.clipboard.writeText(loginText)
      .then(() => {
        // コピー成功時のフィードバック
        const button = e.currentTarget;
        const originalHTML = button.innerHTML;
        button.innerHTML = '<span class="flex items-center"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-1"><path d="M20 6L9 17l-5-5"/></svg>コピーしました</span>';
        button.classList.remove('text-gray-400', 'hover:text-blue-400');
        button.classList.add('text-green-400');
        
        setTimeout(() => {
          button.innerHTML = originalHTML;
          button.classList.remove('text-green-400');
          button.classList.add('text-gray-400', 'hover:text-blue-400');
        }, 2000);
      });
  }

  // ドキュメント全体のクリックを監視して、ツールチップの外をクリックしたら閉じる
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (tooltipRef.current && !tooltipRef.current.contains(e.target)) {
        // ツールチップのボタン以外をクリックした場合
        if (!e.target.closest('.tooltip-button')) {
          setActiveTooltip(null)
        }
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const projects = [
    {
      id: 1,
      title: (
        <>
          AI英会話学習アプリ
          <span className="inline-block min-w-[160px] text-right">（ChatGPT風UI）</span>
        </>
      ),
      description: 'AIを活用した英会話学習アプリ。自然な会話が可能で、翻訳機能や会話の履歴管理を実装。デモ環境で体験可能。',
      loginInfo: 'デモ用メールアドレス / パスワード: test@example.com / password',
      image: '/images/projects/chat-app.png',
      technologies: ['Laravel', 'React', 'Laravel Breeze', 'Flowbite', 'OpenAI API', 'TailwindCSS', 'Docker'],
      liveUrl: 'https://ten-english-app.sakuraweb.com/login',
      githubUrl: 'https://github.com/Ten10sun/AI-English-App.git',
      date: '2025'
    },
    {
      id: 2,
      title: 'Laravel クイズプラットフォーム　（ユーザー画面）',
      description: 'Laravelで構築したフルスタックなクイズプラットフォームのユーザー向けインターフェース。問題の解答と進捗管理が可能。',
      // loginInfo: 'デモ用メールアドレス / パスワード: user@example.com / password123',
      image: '/images/projects/quiz-client.png',
      technologies: ['Laravel', 'TailwindCSS', 'Docker'],
      liveUrl: 'https://ten-quiz-app.sakuraweb.com/',
      githubUrl: 'https://github.com/Ten10sun/lara-qui-app.git',
      date: '2025'
    },
    {
      id: 3,
      title: 'Laravel クイズプラットフォーム　（管理者画面）',
      description: 'Laravel クイズプラットフォームの管理画面。クイズの作成・編集・削除が可能なダッシュボード。デモ環境で体験可能。',
      loginInfo: 'デモ用メールアドレス / パスワード: test@example.com / password123',
      image: '/images/projects/quiz-admin.png',
      technologies: ['Laravel', 'TailwindCSS', 'Docker'],
      liveUrl: 'https://ten-quiz-app.sakuraweb.com/admin/top',
      githubUrl: 'https://github.com/Ten10sun/lara-qui-app.git',
      date: '2025'
    },
    {
      id: 4,
      title: 'React クイズアプリ',
      description: 'Reactで作成したインタラクティブなクイズアプリ。スコア管理機能付き。',
      image: '/images/projects/react-quiz.png',
      technologies: ['React', 'JavaScript', 'CSS', 'Vite', 'Node.js'],
      liveUrl: 'https://react-quiz-chi-three.vercel.app/',
      githubUrl: 'https://github.com/ten10sun/react-quiz',
      date: '2025'
    },
    {
      id: 5,
      title: 'ビジネスサービスサイト',
      description: 'Bootstrapを活用したレスポンシブなウェブサイト。モダンなデザインを実装。',
      image: '/images/projects/business-website.png',
      technologies: ['HTML', 'CSS', 'JavaScript', 'Bootstrap'],
      liveUrl: 'https://website-practice-rho.vercel.app/',
      githubUrl: 'https://github.com/Ten10sun/webSitePractice.git',
      date: '2025'
    },
    {
      id: 6,
      title: '製菓企業サイト',
      description: 'お菓子のブランドサイト。Bootstrapを使用したカラフルなデザイン。',
      image: '/images/projects/candy-brand-site.png',
      technologies: ['HTML', 'CSS', 'JavaScript', 'Bootstrap'],
      liveUrl: 'https://candy-brand-site.vercel.app/',
      githubUrl: 'https://github.com/Ten10sun/CandyBrand_site.git',
      date: '2023'
    },
    {
      id: 7,
      title: 'リゾート施設の紹介サイト',
      description: '美しいギャラリーとレスポンシブデザイン。基礎練習としてBootstrapなどのフレームワークに頼らず制作しました。',
      image: '/images/projects/world-resorts.png',
      technologies: ['HTML', 'CSS', 'JavaScript'],
      liveUrl: 'https://world-resorts.vercel.app/',
      githubUrl: 'https://github.com/Ten10sun/World-Resorts',
      date: '2024'
    },
    {
      id: 8,
      title: '旧ポートフォリオサイト',
      description: '私の旧ポートフォリオサイトです。',
      image: '/images/projects/x-portfolio.png',
      technologies: ['Bootstrap', 'CSS', 'JavaScript'],
      liveUrl: 'https://tenten-portfolio.netlify.app',
      // githubUrl: 'https://github.com/ten10sun/land-of-sweets',
      date: '2025'
    }
  ]

  return (
    <div className="min-h-screen pt-16">
      {/* Header Section */}
      <section className="py-20 section-padding">
        <div className="max-w-6xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center mb-16"
          >
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
              My <span className="gradient-text">Projects</span>
            </h1>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              A collection of projects showcasing my skills in frontend development, backend development,
              UI/UX design, and modern web technologies.
            </p>
          </motion.div>

          {/* Projects Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {projects.map((project, index) => (
              <motion.div
                key={project.id}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: index * 0.1 }}
                className="card-hover bg-white/5 backdrop-blur-sm rounded-2xl overflow-hidden border border-white/10"
              >
                {/* Project Image */}
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="w-full h-full object-cover transition-transform duration-300 hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                </div>

                {/* Project Content */}
                <div className="p-6 relative">
                  <h3 className="text-2xl font-bold text-white mb-3">
                    {project.title}
                  </h3>
                  <p className="text-gray-300 mb-2 line-clamp-3">
                    {project.description}
                  </p>


                  {/* Technologies */}
                  <div className="flex flex-wrap gap-2 mb-4">
                    {project.technologies.map((tech) => (
                      <span
                        key={tech}
                        className="px-3 py-1 bg-white/10 text-white text-sm rounded-full"
                      >
                        {tech}
                      </span>
                    ))}
                  </div>

                  {/* ログイン情報（ポートフォリオ1と3に表示） */}
                  {project.loginInfo && (
                    <div className="mb-4">
                      <div className="flex items-center justify-between bg-gray-800/50 rounded p-2 text-sm">
                        <span className="text-gray-300">{project.loginInfo}</span>
                        <button
                          onClick={(e) => copyLoginInfo(e, project.loginInfo)}
                          className="text-gray-400 hover:text-blue-400 transition-colors relative group"
                          aria-label="ログイン情報をコピー"
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                          </svg>
                          <span className="absolute -top-8 left-1/2 transform -translate-x-1/2 bg-gray-900 text-white text-xs rounded py-1 px-2 whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity">
                            コピー
                          </span>
                        </button>
                      </div>
                    </div>
                  )}

                  {/* Project Links */}
                  <div className="flex gap-4">
                    <a
                      href={project.liveUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-lg hover:shadow-lg transition-all duration-300 hover:scale-105"
                    >
                      <ExternalLink size={16} />
                      サイトを見る
                    </a>
                    {project.githubUrl && (
                      <a
                        href={project.githubUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-2 px-4 py-2 bg-blue-600/20 hover:bg-blue-600/30 text-white rounded-lg transition-all duration-300 hover:scale-105"
                      >
                        <Github size={16} />
                        Code
                      </a>
                    )}
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 section-padding">
        <div className="max-w-4xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Interested in Working Together?
            </h2>
            <p className="text-xl text-gray-300 mb-8">
              I'm always open to discussing new opportunities and exciting projects.
            </p>
            <motion.a
              href="/about"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-blue-600 to-purple-600 text-white font-semibold rounded-full hover:shadow-2xl transition-all duration-300"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
              About Me
            </motion.a>
          </motion.div>
        </div>
      </section>
      
      {/* グローバルなツールチップ用のスタイル */}
      <style jsx="true" global="true">{`
        .tooltip {
          position: absolute;
          z-index: 50;
          pointer-events: none;
          transition: opacity 0.2s ease-in-out;
        }
      `}</style>
    </div>
  )
}

export default Projects
